/**
 * Export list directive
 * @author Ryan Gladstone
 * <export-list></export-list>
 */

import template from './exportList.html';

function directive() {
  return {
    restrict: 'AE',
    scope: {
      filterSet: '='
    },
    template,
    controller: 'ExportListController'
  };
}

function ExportListController($scope, $location, analyticsService) {
  $scope.export = () => {
    let url = $location.url();
    // Does the URL already have query parameters?
    if (url.indexOf('?') > -1) {
      // if so, prepare to append another one
      url += '&';
    } else {
      // if not, prepare to add the first query param
      url += '?';
    }

    analyticsService.trackEvent('Export stories', 'export initiated');

    $location.url(`/export${url}size=50`);
  };
}

const controllerArray = [
  '$scope',
  '$location',
  'analyticsService',
  ExportListController
];

export default function (ngModule) {
  ngModule.directive('exportList', directive);
  ngModule.controller('ExportListController', controllerArray);
}
